import getParamsFromUrl from '@/utils/shareSource'
import useIsEdu from '@/hooks/useIsEdu'
const { isEdu } = useIsEdu()

export const unload = () => {
  window.collectEvent?.('app_terminate')
}

function getDeviceInfo(): {
  device: 'mobile' | 'desktop'
  browser: string
  system: 'Apple' | 'Windows' | 'Other'
} {
  const userAgent = navigator.userAgent.toLowerCase()

  // 获取设备类型
  let device: 'mobile' | 'desktop'
  if (/mobile|android|iphone|ipad|ipod/i.test(userAgent)) {
    device = 'mobile'
  } else {
    device = 'desktop'
  }

  // 获取浏览器类型
  let browser = 'Other'
  if (userAgent.indexOf('chrome') > -1) {
    browser = 'Chrome'
  } else if (userAgent.indexOf('safari') > -1) {
    browser = 'Safari'
  } else if (userAgent.indexOf('firefox') > -1) {
    browser = 'Firefox'
  } else if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
    browser = 'Internet Explorer'
  }

  // 获取用户系统类型
  let system: 'Apple' | 'Windows' | 'Other' = 'Other'
  if (userAgent.indexOf('mac os') > -1) {
    system = 'Apple'
  } else if (userAgent.indexOf('windows') > -1) {
    system = 'Windows'
  }

  return {
    device,
    browser,
    system
  }
}

const trackInit = () => {
  const info = getDeviceInfo()
  const hostname = window.location.hostname
  const enableDebug =
    !hostname.startsWith('zaohaowu') && !hostname.startsWith('edu') && !hostname.startsWith('www')

  // 初始化
  window.collectEvent?.('init', {
    app_id: 20008168,
    enable_debug: enableDebug,
    enable_stay_duration: true,
    channel_domain: 'https://gator.volces.com',
    log: false,
    autotrack: true //全埋点开关
  })
  // 配置公共属性
  window.collectEvent?.('config', {
    device_category: info.device,
    browser_brand_name: info.browser,
    operating_system: info.system,
    isEdu: isEdu ? 1 : 0,
    ht_source: getParamsFromUrl('ht_source') || sessionStorage.getItem('ht_source') || ''
  })
  // 自埋点：启动
  window.collectEvent?.('app_launch')
  // SDK开始采集
  window.collectEvent?.('start')

  // 获取web_id
  window.collectEvent?.('getToken', (token: any) => {
    localStorage.setItem('web_id', token.web_id)
  })

  // 自埋点：关闭网页
  window.addEventListener('beforeunload', unload)

  if (window.matchMedia('(display-mode: standalone)').matches) {
    window.dataLayer &&
      window.dataLayer.push({
        behavior: 'PWA'
      })
    window.collectEvent?.('config', {
      behavior: 'PWA'
    })
  }
}
export default trackInit
